import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../../config/api";
import DOMPurify from "dompurify";
import Cookies from "js-cookie";

interface EmailDetails {
    id: number;
    htmlBody: string;
}

export default function ViewEmailBody() {
    const token = Cookies.get("token-express-tire");
    const { id } = useParams();
    const navigate = useNavigate();
    const [email, setEmail] = useState<EmailDetails | null>(null);

    useEffect(() => {
        if (!token) {
            navigate("*", { replace: true });
            return;
        }

        if (!id) {
            navigate("*", { replace: true });
            return;
        }

        fetch(`${baseURL}emailLogs/GetEmailDetail/${id}`)
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                if (!data) {
                    navigate("*", { replace: true });
                }
                setEmail(data);
            })
            .catch(() => {
                navigate("*", { replace: true });
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (!email) return <div className="flex flex-col items-center justify-center h-screen gap-3">
        <div className="animate-spin h-10 w-10 border-4 border-gray-300 border-t-blue-600 rounded-full" />
        <p className="text-gray-600">Loading email…</p>
    </div>;

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-4">Email Preview</h2>

            <iframe
                title="Email Preview"
                style={{
                    width: "100%",
                    height: "calc(100vh - 4.75rem)",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    background: "white"
                }}
                srcDoc={DOMPurify.sanitize(email.htmlBody)}
            />

        </div>
    );
}
